import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { HotmartAIEndpoints } from 'src/services/hotmartAI'
import HotmartAIService from 'src/services/hotmartAI/service'
import { MAX_RETRIES, RETRY_DELAY } from './useAIGetCompletion.constants'

const useAIGetCompletion = (uuid: string) => {
  const fetchCompletion = async () => {
    const response = await HotmartAIService.getCompletion(uuid)
    const isEmptyResponse = !response || !Object.keys(response).length

    /**
     * A API do Hotmart AI retorna um objeto vazio quando a requisição ainda está em andamento.
     * Para evitar que o usuário veja um comentário vazio, é necessário que a requisição seja
     * feita novamente até que o retorno seja válido respeitando o número máximo de tentativas.
     */
    /* istanbul ignore next */
    if (isEmptyResponse) {
      throw new Error('Empty response in `/v1/completions/${uuid}` endpoint')
    }

    return response
  }

  const endpoint = HotmartAIEndpoints.getCompletion(uuid)

  return useHotRequest(endpoint, {
    cacheKey: [endpoint],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_HOTMART_AI,
    queryOptions: {
      queryFn: () => fetchCompletion(),
      enabled: Boolean(uuid),
      retry: MAX_RETRIES,
      retryDelay: RETRY_DELAY
    }
  })
}

export default useAIGetCompletion
